export type FullPreviewVariants = "default" | "paywall_customization";

export const DEFAULT_FULL_PREVIEW_VARIANT: Record<
  FullPreviewVariants,
  FullPreviewVariants
> = {
  default: "default",
  paywall_customization: "paywall_customization",
};
